export const headerSales = {
  template: require('./headerSales.html')
};